import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ToastContainer } from 'react-toastify';
import { Typography, Button, Box, IconButton, Snackbar, Alert, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility.js';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff.js';
// LoaderContainer removed - using only lazy loading for better UX
import Alerts from "../../../components/Alerts/alerts.js";
import AuthService from "../../Authentication_usertypes/auth.service.js";
import AlertService from "../../../components/Alerts/alerts.js";
import DashboardService from "../dashboard.service.js";
import ConfigurationService from "../../Configuration/configuration.service.js";
import emotionStyled from '@emotion/styled';
import Header from './Header.js';
import Footer from './Footer.js';
import { CategoryContent } from './CategoryComponent.js';
import LazyWrapper from '../../../components/LazyWrapper.js';
import MyProfile from '../../Profile/MyProfile.js';
import MyOrders from './CustomerOrders.js';
import CheckoutPage from './CheckoutPage.js';
import Sidebar from './Sidebar.js';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PopupModal from './PopupModal.js'; // Import the PopupModal component
import { useStoreScrollRestoration } from '../../../hooks/useScrollRestoration.js';
import { scrollToTop } from '../../../utils/scrollUtils.js';
import { useCart } from '../../../context/CartContext.js';


const PhoneInputContainer = emotionStyled.div`
  display: flex;
  width: 100%;
  border: 1px solid #EEEEEE;
  border-radius: 5px;
  overflow: hidden;
`;

const CountryCodeSelect = emotionStyled.select`
  padding: 10px;
  border: none;
  background-color: #FEFEFE;
  color: #9897A1;
  font-size: 16px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%239897A1" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 30px;
`;

const PhoneInput = emotionStyled.input`
  flex-grow: 1;
  padding: 10px;
  border: none;
  color: #9897A1;
  background-color: #FEFEFE;
  font-size: 16px;
  &:focus {
    outline: none;
  }
`;

const App = () => {
  const { cartState, fetchCartData: fetchCartDataGlobal } = useCart();
  const [activeCategory, setActiveCategory] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const categoryRefs = useRef({});
  const location = useLocation();
  const navigate = useNavigate();

  // Use scroll restoration hook
  const { scrollToTop: scrollToTopSmooth } = useStoreScrollRestoration();
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showBranchPopup, setShowBranchPopup] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Branch, setBranch] = useState('');
  const [branches, setBranches] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [pageLimit, setPageLimit] = useState(20);
  const [pageIndex, setPageIndex] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [products, setProducts] = useState([]);
  const [tempCart, setTempCart] = useState([]);
  const [selectedVariations, setSelectedVariations] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbar1, setOpenSnackbar1] = useState(false);
  const [openSnackbar2, setOpenSnackbar2] = useState(false);
  const [userData, setUser] = useState(null);

  // Prevent global cart sync from clobbering optimistic local updates
  const [ignoreGlobalCartUntil, setIgnoreGlobalCartUntil] = useState(0);

  // Function to refresh user data from localStorage
  const refreshUserData = useCallback(() => {
    const userString = localStorage.getItem('user');
    if (userString) {
      setUser(JSON.parse(userString));
    }
  }, []);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [registerError, setRegisterError] = useState('');
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [registerForm, setRegisterForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [showProfile, setShowProfile] = useState(false);
  const [showOrders, setShowOrders] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);

  // Enhanced state setters with scroll restoration
  const setShowProfileWithScroll = (value) => {
    setShowProfile(value);
    if (value) {
      setTimeout(() => scrollToTop('auto'), 100);
    }
  };

  const setShowOrdersWithScroll = (value) => {
    setShowOrders(value);
    if (value) {
      setTimeout(() => scrollToTop('auto'), 100);
    }
  };

  const setShowCheckoutWithScroll = (value) => {
    setShowCheckout(value);
    if (value) {
      setTimeout(() => scrollToTop('auto'), 100);
    }
  };
  const [productDetails, setProduct_Details] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const scrollRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState('');
  const [banners, setBanners] = useState([]);
  const [productStock, setProductStock] = useState({}); // Add state for product stock information
  const [stockWarningShown, setStockWarningShown] = useState({}); // Track which stock warnings have been shown
  const [incrementCooldown, setIncrementCooldown] = useState({}); // Track cooldown for increment buttons

  useEffect(() => {
    if (scrollRef.current) {
      const ps = new PerfectScrollbar(scrollRef.current);
      return () => ps.destroy();
    }
  }, [scrollRef, sidebarOpen]);

  useEffect(() => {
    const userString = localStorage.getItem('user');
    if (userString) {
      setUser(JSON.parse(userString));
    }
  }, []);
  useEffect(() => {
    if (Branch !== '') {
      // Reset pagination and products on branch change
      setProducts([]);
      setCategorizedProducts({});
      setPageIndex(1);
      setHasMore(true);
      fetchCategories(0, pageLimit);
      // Clear product stock when branch changes
      setProductStock({});
    }
  }, [Branch]);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchBusiness()
    getSystemConfig();
    fetchActiveBanners();
    fetchCartDataGlobal();
    // If navigated here with intent to view orders, open orders list
    const shouldOpenOrders = localStorage.getItem('openOrders') === '1';
    if (shouldOpenOrders) {
      setShowProfile(false);
      setShowCheckout(false);
      setProduct_Details(null);
      setShowOrders(true);
      localStorage.removeItem('openOrders');
    }
  }, []);
  // Keep local tempCart in sync with global cart
  useEffect(() => {
    if (cartState?.cartData) {
      // If we're within the ignore window, skip applying global cart snapshot
      if (Date.now() < ignoreGlobalCartUntil) {
        return;
      }
      try {
        const mapped = cartState.cartData.map((item) => ({
          business_id: item?.business_details?._id,
          category_id: item?.category_details?._id,
          product_id: item?.product_details?._id,
          quantity: parseInt(item?.quantity) || 0,
          price: parseFloat(item?.price) || 0,
          variations: item?.variations || [],
          total_price: parseFloat(item?.total_price) || ((parseFloat(item?.price) || 0) * (parseInt(item?.quantity) || 0))
        }));
        setTempCart(mapped);
      } catch (_) { /* no-op */ }
    }
  }, [cartState?.cartData, ignoreGlobalCartUntil]);

  const fetchActiveBanners = () => {
    setLoading(true);
    DashboardService.getActiveBannersCustomer()
      .then((response) => {
        setLoading(false);
        if (response.data.status) {
          //iph todo: 47
          //console.log("my active banners", response.data.data)
          setBanners(response.data.data);
        } else {
          //iph todo: 47
          //console.error("Failed to fetch active banners");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching active banners:", error);
      });
  };

  function getSystemConfig() {
    ConfigurationService.getConfiguration().then((response) => {
      //iph todo: 47
      //console.log("API Response:-", response);
      if (response.data.status) {
        setColors(response.data.data[0].buttons_color, '--buttons-color');
        setColors(response.data.data[0].topbar_color, '--topbar-color');
        setColors(response.data.data[0].leftbar_color, '--leftbar-color');
        setColors(response.data.data[0].buttons_text_color, '--buttons-text-color');
        setSystemLogo(response.data.data[0].system_logo);
      }
      else {
        setColors('#3ac47d', 'onerror');
      }
    },
      (error) => {
        setColors('#3ac47d', 'onerror');
      });
  }

  function setColors(color, param) {
    if (param === '--buttons-color') {
      localStorage.setItem("buttons_color", color);
      document.documentElement.style.setProperty('--buttons-color', color)
    }
    if (param === '--topbar-color') {
      localStorage.setItem("topbar_color", color);
      document.documentElement.style.setProperty('--topbar-color', color)
    }
    if (param === '--leftbar-color') {
      localStorage.setItem("leftbar_color", color);
      document.documentElement.style.setProperty('--leftbar-color', color)
    }
    if (param === '--buttons-text-color') {
      localStorage.setItem("buttons_text_color", color);
      document.documentElement.style.setProperty('--buttons-text-color', color)
    }
    if (param === 'onerror') {
      localStorage.setItem("buttons_color", color);
      localStorage.setItem("topbar_color", '#fff');
      localStorage.setItem("leftbar_color", '#fff');
      localStorage.setItem("buttons_text_color", '#fff');
      document.documentElement.style.setProperty('--buttons-color', color)
      document.documentElement.style.setProperty('--topbar-color', '#fff')
      document.documentElement.style.setProperty('--leftbar-color', '#fff')
      document.documentElement.style.setProperty('--buttons-text-color', '#fff')
    }
  }

  function setSystemLogo(sys_logo) {
    setLogo(sys_logo);
    localStorage.setItem("system_logo", sys_logo);
  }
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Always scroll to top when route or internal view changes
  const forceScrollTop = useCallback(() => {
    try {
      window.scrollTo({ top: 0, behavior: 'auto' });
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    } catch (_) { /* no-op */ }
  }, []);

  // On route change
  useEffect(() => {
    forceScrollTop();
  }, [location.pathname, forceScrollTop]);

  // On internal view toggles
  useEffect(() => { forceScrollTop(); }, [showProfile, forceScrollTop]);
  useEffect(() => { forceScrollTop(); }, [showOrders, forceScrollTop]);
  useEffect(() => { forceScrollTop(); }, [showCheckout, forceScrollTop]);

  useEffect(() => {
    if (branches.length > 0 && !Branch) {
      setBranch(branches[0]?._id);
    }
  }, [branches, Branch, setBranch]);

  useEffect(() => {
    if (selectedCategory !== undefined) {
      // Reset pagination when category changes
      setProducts([]);
      setCategorizedProducts({});
      setPageIndex(1);
      setHasMore(true);
      fetchProducts(1, pageLimit).catch(error => {
        console.error('Error fetching products:', error);
      });
    }
  }, [selectedCategory, Branch]);
  //iph todo: 47
  //console.log("activeCategory", activeCategory)
  //iph todo: 47
  //console.log("category", categories)
  const fetchExistingCart = async () => {
    try {
      setLoading(true);
      const userString = localStorage.getItem('user');
      const user = JSON.parse(userString);
      const userId = user['_id'];
      const updateData = {
        "functionName": "GetCartList",
        "postData": {
          "user_id": userId,
          "filters": {
            "status": false,
            "coupan_code": '',
            "prioritize": "",
            "quantity": {
              "cart_id": '',
              "quantity": ''
            }
          }
        }
      };
      const response = await DashboardService.GetCartList(updateData);
      if (response.data && response.data.cartData) {
        const existingCartItems = response.data.cartData.map(item => ({
          business_id: item.business_details?._id,
          category_id: item.category_details?._id,
          product_id: item.product_details?._id,
          quantity: parseInt(item?.quantity),
          price: parseFloat(item?.price),
          variations: item?.variations || []
        }));
        setTempCart(existingCartItems);
      }
    } catch (error) {
      console.error('Error fetching existing cart:', error);
    } finally {
      setLoading(false);
    }
  };
  const [categorizedProducts, setCategorizedProducts] = useState({});

  function fetchCategories(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    setLoading(true);
    let branches = [];
    if (Branch) {
      branches.push(Branch)
    }
    DashboardService.getAllCategories(offset, page_limit, branches).then((response) => {
      setLoading(false);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        if (response.data.data) {
          //iph todo: 47
          //console.log("ALL Category", response.data.data);
          setCategories(response.data.data);
          if (response.data.data.length > 0) {
            setSelectedCategory(response.data.data[0]._id);
          }
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };

  function fetchBusiness() {
    setLoading(true);
    DashboardService.getAllBusiness().then((response) => {
      setLoading(false);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        if (response.data.data) {
          //iph todo: 47
          //console.log("ALL Business", response.data.data);
          setBranches(response.data.data);
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };

  // Function to fetch stock information for products
  const fetchProductStock = async (products) => {
    try {
      //iph todo: 47
      //console.log('🚀 fetchProductStock function called!');
      //iph todo: 47
      //console.log('Fetching stock for products:', products.length);
      //iph todo: 47
      //console.log('First product:', products[0]);
      //iph todo: 47
      //console.log('Current Branch:', Branch);

      if (!products || products.length === 0) {
        //iph todo: 47
        //console.log('❌ No products to fetch stock for');
        return;
      }

      // Process products in batches to avoid overwhelming the server
      const BATCH_SIZE = 5;
      for (let i = 0; i < products.length; i += BATCH_SIZE) {
        const batch = products.slice(i, i + BATCH_SIZE);

        //iph todo: 47
        //console.log(`🔄 Processing batch ${Math.floor(i / BATCH_SIZE) + 1}, products ${i + 1} to ${Math.min(i + BATCH_SIZE, products.length)}`);

        const stockPromises = batch.map(async (product) => {
          try {
            //iph todo: 47
            //console.log(`📦 Fetching stock for: ${product.item_name} (item_code: ${product.item_code})`);

            // Validate that item_code exists and is not empty
            if (!product.item_code) {
              //iph todo: 47
              //console.error(`❌ Product ${product.item_name} has no item_code!`);
              return { productId: product._id, stock: 0 };
            }

            // Use item_code to fetch stock for this specific item only
            //iph todo: 47
            //console.log(`🚀 About to call getBatchesForItem with item_code: "${product.item_code}", branch: ${Branch}`);
            //iph todo: 47
            //console.log(`📡 Making API call to StockModule/GetStocks...`);

            const response = await DashboardService.getBatchesForItem(product.item_code, Branch ? [Branch] : []);
            //iph todo: 47
            //console.log(`📥 API response received for ${product.item_name}:`, response);

            if (response.data && response.data.data && Array.isArray(response.data.data)) {
              //iph todo: 47
              //console.log(`Raw API response for ${product.item_name}:`, response.data);

              // Log all item_codes in the response to see if server filtering worked
              const responseItemCodes = response.data.data.map(batch => batch.item_code);
              //iph todo: 47
              //console.log(`Server returned batches for item_codes: [${responseItemCodes.join(', ')}] when requesting: ${product.item_code}`);

              // Double-check: Filter batches to ensure they match the requested item_code
              // This is a client-side safety check in case server-side filtering isn't working
              const filteredBatches = response.data.data.filter(batch => batch.item_code === product.item_code);

              //iph todo: 47
              //console.log(`API returned ${response.data.data.length} batches, filtered to ${filteredBatches.length} for ${product.item_name} (${product.item_code})`);

              // Warn if server returned batches for wrong item_code
              if (response.data.data.length > filteredBatches.length) {
                //iph todo: 47
                //console.warn(`❌ Server-side filtering NOT working! Server returned batches for multiple item_codes when requesting ${product.item_code}`);
                //iph todo: 47
                //console.log('All batches returned:', response.data.data.map(b => ({ item_code: b.item_code, quantity: b.quantity, batch_number: b.batch_number })));
              } else if (filteredBatches.length === response.data.data.length && filteredBatches.length > 0) {
                //iph todo: 47
                //console.log(`✅ Server-side filtering working correctly for ${product.item_code}`);
              }

              // Calculate total available stock from filtered batches
              const totalStock = filteredBatches.reduce((sum, batch) => {
                // Only count active batches with positive quantity
                if (batch.status === 'Active' && batch.quantity > 0) {
                  //iph todo: 47
                  //console.log(`Adding batch ${batch.batch_number}: ${batch.quantity} units for ${product.item_name}`);
                  return sum + batch.quantity;
                }
                return sum;
              }, 0);

              //iph todo: 47
              //console.log(`Total stock for ${product.item_name}: ${totalStock}`);

              return { productId: product._id, stock: totalStock };
            } else {
              //iph todo: 47
              //console.log(`No stock data found for ${product.item_name}`);
              return { productId: product._id, stock: 0 };
            }
          } catch (error) {
            console.error(`Error fetching stock for ${product.item_code}:`, error);
            return { productId: product._id, stock: 0 };
          }
        });

        // Wait for current batch to complete
        const batchResults = await Promise.all(stockPromises);

        // Update stock for this batch
        batchResults.forEach(({ productId, stock }) => {
          setProductStock(prev => ({
            ...prev,
            [productId]: stock
          }));
        });

        // Small delay between batches
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      //iph todo: 47
      //console.log('Finished fetching stock for all products');
    } catch (error) {
      console.error('Error fetching product stock:', error);
    }
  };





  // Modify the fetchProducts function
  async function fetchProducts(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    // set loading flags
    if (page_index === 1) {
      setLoading(true);
    } else {
      setIsFetchingMore(true);
    }
    let branch = [];
    if (Branch !== '') {
      branch.push(Branch)
    }
    let Category = [];
    categories.forEach((category) => {
      Category.push(category?._id)
    })
    if (Category?.length > 0 && branch.length > 0) {
      try {
        const response = await DashboardService.getAllProducts(offset, page_limit, Category, branch);
        if (page_index === 1) setLoading(false); else setIsFetchingMore(false);

        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          if (response.data.data) {
            //iph todo: 47
            //console.log("ALL Products", response.data.data);
            const newPageItems = response.data.data || [];
            // If first page replace, else append unique by _id
            setProducts(prev => {
              if (page_index === 1) return newPageItems;
              const seen = new Set(prev.map(p => p._id));
              const append = newPageItems.filter(p => !seen.has(p._id));
              return [...prev, ...append];
            });
            // Update hasMore based on returned count
            setHasMore((response.data.data || []).length >= page_limit);

            // Categorize products
            const categorized = {};
            // Use accumulated list to keep categories consistent
            const sourceList = (page_index === 1)
              ? (response.data.data || [])
              : (function () { /* merge with existing */
                const current = [];
                // We'll merge after state update in next tick; approximate by combining
                return [];
              })();
            (response.data.data || []).forEach(product => {
              if (!categorized[product.category]) {
                categorized[product.category] = [];
              }
              categorized[product.category].push(product);
            });
            // For pagination, build categories from the full products after state updates
            setCategorizedProducts(prev => {
              const merged = { ...prev };
              (response.data.data || []).forEach(product => {
                if (!merged[product.category]) merged[product.category] = [];
                // avoid duplicates
                if (!merged[product.category].some(p => p._id === product._id)) {
                  merged[product.category].push(product);
                }
              });
              return page_index === 1 ? categorized : merged;
            });

            // Fetch stock for only the newly loaded products
            try {
              await fetchProductStock(response.data.data || []);
            } catch (error) { /* no-op */ }
          }
        }
      } catch (error) {
        if (page_index === 1) setLoading(false); else setIsFetchingMore(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      }
    }
  };

  // Infinite scroll via IntersectionObserver
  const loadMoreRef = useRef(null);
  useEffect(() => {
    if (!hasMore) return;
    const el = loadMoreRef.current;
    const rootEl = scrollRef.current;
    if (!el || !rootEl) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isFetchingMore && hasMore) {
          const nextPage = pageIndex + 1;
          setPageIndex(nextPage);
          fetchProducts(nextPage, pageLimit);
        }
      });
    }, { root: rootEl, rootMargin: '400px 0px', threshold: 0 });
    observer.observe(el);
    return () => observer.disconnect();
  }, [pageIndex, pageLimit, hasMore, isFetchingMore, selectedCategory, Branch]);

  // Fallback: manual scroll listener in case IntersectionObserver doesn't fire
  useEffect(() => {
    const rootEl = scrollRef.current;
    if (!rootEl) return;
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const nearBottom = rootEl.scrollTop + rootEl.clientHeight >= rootEl.scrollHeight - 500;
        if (nearBottom && hasMore && !isFetchingMore) {
          const nextPage = pageIndex + 1;
          setPageIndex(nextPage);
          fetchProducts(nextPage, pageLimit);
        }
        ticking = false;
      });
    };
    rootEl.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      rootEl.removeEventListener('scroll', onScroll);
    };
  }, [pageIndex, pageLimit, hasMore, isFetchingMore, selectedCategory, Branch]);

  const handleVariationChange = (product, variationGroup, type, isChecked) => {
    // Check if product is in stock before allowing variation changes
    const currentStock = productStock[product._id] || 0;
    if (currentStock <= 0) {
      AlertService.swalErrorAlert(t("This product is currently out of stock."));
      return;
    }

    setTempCart(prev => {
      const productIndex = prev.findIndex(item => item.product_id === product._id);
      if (productIndex === -1) {
        // If product is not in cart, add it with the selected variation
        const newItem = {
          business_id: product.business_id,
          category_id: product.category,
          product_id: product._id,
          quantity: 1,
          price: parseFloat(product.price),
          variations: [{
            variation_id: variationGroup.Variation._id,
            variation_name: variationGroup.Variation.name,
            variation_option_id: type._id,
            variation_type_name: type.variation_type_name,
            variation_price: parseFloat(type.price)
          }],
          total_price: parseFloat(product.price) + parseFloat(type.price)
        };
        return [...prev, newItem];
      }

      const updatedCart = [...prev];
      const cartItem = { ...updatedCart[productIndex] };

      if (isChecked) {
        cartItem.variations.push({
          variation_id: variationGroup.Variation._id,
          variation_name: variationGroup.Variation.name,
          variation_option_id: type._id,
          variation_type_name: type.variation_type_name,
          variation_price: parseFloat(type.price)
        });
      } else {
        cartItem.variations = cartItem.variations.filter(
          v => !(v.variation_id === variationGroup.Variation._id && v.variation_option_id === type._id)
        );
      }

      const basePrice = parseFloat(cartItem.price);
      const variationTotal = cartItem.variations.reduce((sum, v) => sum + v.variation_price, 0);
      cartItem.total_price = (basePrice + variationTotal) * cartItem.quantity;

      updatedCart[productIndex] = cartItem;
      setCart(JSON.parse(localStorage.getItem('user'))._id, updatedCart);
      return updatedCart;
    });
  };


  const CartView = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
    } else {
      navigate('/CartView')
    }
  };


  const handleIncrement = (product) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
    } else {
      // Block increment if price is missing/zero
      const priceValue = parseFloat(product?.price);
      if (!Number.isFinite(priceValue) || priceValue <= 0) {
        AlertService.swalErrorAlert(t('Price is missing for that item'));
        return;
      }
      // Check if button is in cooldown
      if (incrementCooldown[product._id]) {
        //iph todo: 47
        //console.log(`Button in cooldown for product ${product._id}`);
        return;
      }

      // Set cooldown for this product
      setIncrementCooldown(prev => ({
        ...prev,
        [product._id]: true
      }));

      // Clear cooldown after 500ms
      setTimeout(() => {
        setIncrementCooldown(prev => ({
          ...prev,
          [product._id]: false
        }));
      }, 500);

      // Check if adding one more would exceed available stock
      const currentStock = productStock[product._id] || 0;
      const existingItem = tempCart.find(item => item.product_id === product._id);
      const currentQuantity = existingItem ? existingItem.quantity : 0;

      //iph todo: 47
      //console.log(`handleIncrement called for product ${product._id}:`, {
      //   currentStock,
      //   currentQuantity,
      //   wouldExceed: currentQuantity + 1 > currentStock
      // });

      // Check if the button should be disabled (quantity already at stock limit)
      if (currentQuantity >= currentStock) {
        //iph todo: 47
        //console.log(`Button should be disabled - quantity already at stock limit`);
        return; // Don't show warning, just return
      }

      if (currentQuantity + 1 > currentStock) {
        // Only show warning when actually trying to exceed stock limit
        // Use info alert instead of error alert
        // Prevent showing the same warning multiple times
        if (!stockWarningShown[product._id]) {
          //iph todo: 47
          //console.log(`Showing stock warning: Only ${currentStock} items available`);
          AlertService.swalInfoAlert(t(`Only ${currentStock} items available in stock.`));
          // Mark this warning as shown for this product
          setStockWarningShown(prev => ({
            ...prev,
            [product._id]: true
          }));
          // Reset the warning after 5 seconds
          setTimeout(() => {
            setStockWarningShown(prev => ({
              ...prev,
              [product._id]: false
            }));
          }, 5000);
        }
        return;
      }

      setTempCart(prev => {
        const existingProductIndex = prev.findIndex(item => item.product_id === product._id);

        if (existingProductIndex > -1) {
          const updatedCart = [...prev];
          updatedCart[existingProductIndex] = {
            ...updatedCart[existingProductIndex],
            quantity: updatedCart[existingProductIndex].quantity + 1,
            total_price: (updatedCart[existingProductIndex].quantity + 1) *
              (parseFloat(product.price) + updatedCart[existingProductIndex].variations.reduce((sum, v) => sum + v.variation_price, 0))
          };
          return updatedCart;
        } else {
          const newCart = [
            ...prev,
            {
              business_id: product.business_id,
              category_id: product.category,
              product_id: product._id,
              quantity: 1,
              price: parseFloat(product.price),
              variations: [],
              total_price: parseFloat(product.price)
            }
          ];
          return newCart;
        }
      });
    }
  };

  const handleAddToCart = async (product, quantity, sync = false) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
    } else {
      // Prevent add/update when price is missing/zero
      const priceValue = parseFloat(product?.price);
      if (!Number.isFinite(priceValue) || priceValue <= 0) {
        AlertService.swalErrorAlert(t('Price is missing for that item'));
        return;
      }
      // Only enforce cooldown for non-sync calls (e.g., stepper clicks). Add/Add to cart should always persist.
      if (!sync) {
        if (incrementCooldown[product._id]) {
          //iph todo: 47
          //console.log(`handleAddToCart in cooldown for product ${product._id}`);
          return;
        }
        // Set cooldown for this product
        setIncrementCooldown(prev => ({
          ...prev,
          [product._id]: true
        }));
        // Clear cooldown after 500ms
        setTimeout(() => {
          setIncrementCooldown(prev => ({
            ...prev,
            [product._id]: false
          }));
        }, 500);
      }

      // Check if product is in stock before adding to cart
      const currentStock = productStock[product._id] || 0;
      if (quantity > 0 && currentStock <= 0) {
        AlertService.swalErrorAlert(t("This product is currently out of stock."));
        return;
      }

      // Check if requested absolute quantity would exceed available stock
      if (quantity > 0) {
        const desiredQuantity = quantity;
        //iph todo: 47
        //console.log(`handleAddToCart stock check (absolute) for product ${product._id}:`, {
        //   desiredQuantity,
        //   currentStock,
        //   wouldExceed: desiredQuantity > currentStock
        // });
        if (desiredQuantity > currentStock) {
          if (!stockWarningShown[product._id]) {
            AlertService.swalInfoAlert(t(`Only ${currentStock} items available in stock.`));
            setStockWarningShown(prev => ({ ...prev, [product._id]: true }));
            setTimeout(() => {
              setStockWarningShown(prev => ({ ...prev, [product._id]: false }));
            }, 5000);
          }
          return;
        }
      }

      // Build next cart deterministically from current tempCart
      const currentCart = Array.isArray(tempCart) ? [...tempCart] : [];
      const existingProductIndex = currentCart.findIndex(item => item.product_id === product._id);
      let nextCartSnapshot = null;

      if (existingProductIndex > -1) {
        if (quantity >= 1) {
          const updatedCart = [...currentCart];
          updatedCart[existingProductIndex] = {
            ...updatedCart[existingProductIndex],
            quantity: quantity,
            total_price: quantity * (
              parseFloat(product.price) +
              updatedCart[existingProductIndex].variations.reduce((sum, v) => sum + v.variation_price, 0)
            )
          };
          nextCartSnapshot = updatedCart;
        } else {
          const newCart = currentCart.filter(item => item.product_id !== product._id);
          nextCartSnapshot = newCart;
        }
      } else {
        const newCart = [
          ...currentCart,
          {
            business_id: product.business_id,
            category_id: product.category,
            product_id: product._id,
            quantity: quantity,
            price: parseFloat(product.price),
            variations: [],
            total_price: quantity * parseFloat(product.price)
          }
        ];
        nextCartSnapshot = newCart;
        // Success toast will only be shown by setCart success branch
      }

      // Update local state immediately
      setTempCart(nextCartSnapshot);
      // Open a short window to ignore incoming global cart reshapes to avoid flicker
      setIgnoreGlobalCartUntil(Date.now() + 1500);

      // Persist to server
      const userId = JSON.parse(localStorage.getItem('user'))?._id;
      if (sync && userId) {
        if (nextCartSnapshot.length === 0) {
          await deleteCart(userId);
        } else {
          await setCart(userId, nextCartSnapshot);
        }
      }
      return true;
    }
  };

  const handleDecrement = (product) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
    } else {
      setTempCart(prev => {
        const existingProductIndex = prev.findIndex(item => item.product_id === product._id);
        if (existingProductIndex > -1) {
          if (prev[existingProductIndex].quantity > 1) {
            const updatedCart = [...prev];
            const itemTotalPrice = parseFloat(product.price) +
              updatedCart[existingProductIndex].variations.reduce((sum, v) => sum + v.variation_price, 0);
            updatedCart[existingProductIndex] = {
              ...updatedCart[existingProductIndex],
              quantity: updatedCart[existingProductIndex].quantity - 1,
              total_price: (updatedCart[existingProductIndex].quantity - 1) * itemTotalPrice
            };
            return updatedCart;
          } else {
            const newCart = prev.filter(item => item.product_id !== product._id);
            const userId = JSON.parse(localStorage.getItem('user'))._id;
            if (newCart.length === 0) {
              deleteCart(userId);
            } else {
              setCart(userId, newCart);
            }
            AlertService.successToast(t('Removed from cart'));
            return newCart;
          }
        }
        return prev;
      });
    }
  };

  // Explicit sync action to persist current local cart to server (for Add button)
  const syncCartNow = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      setShowLoginPopup(true);
      return;
    }
    // Avoid flicker from immediate global refresh overriding local snapshot
    setIgnoreGlobalCartUntil(Date.now() + 1500);
    setCart(user._id, tempCart);
    AlertService.successToast(t('Cart updated'));
  };

  const handleLoginInputChange = (e) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({ ...prev, [name]: value }));
  };

  const handleRegisterInputChange = (e) => {
    const { name, value } = e.target;
    setRegisterForm(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (formData) => {
    setLoading(true);
    try {
      const response = await AuthService.login(formData.email, formData.password, 'customers');
      setLoading(false);
      AlertService.successToast(t("Login Successful."));
      localStorage.setItem("user", JSON.stringify(response));
      setShowLoginPopup(false);
      setUser(response);
      window.location.reload();
    } catch (error) {
      setLoading(false);
      setLoginError(t('Invalid Credentials'));
    }
  };

  const toggleLoginRegister = () => {
    setShowLoginPopup(!showLoginPopup);
    setShowRegisterPopup(!showRegisterPopup);
    // Reset form fields and errors
    setEmail('');
    setPassword('');
    setName('');
    setConfirmPassword('');
    setLoginError('');
    setRegisterError('');
  };

  const LoginPopup = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const handleSubmit = (e) => {
      e.preventDefault();
      handleLogin({ email, password });
    };

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1002,
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          width: '100%',
          maxWidth: '500px',
          position: 'relative',
        }}>
          <IconButton
            onClick={() => setShowLoginPopup(false)}
            style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              color: '#000',
            }}
          >
            ←
          </IconButton>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <img src={logo} alt="Logo" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />
          </div>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Email</Typography>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                ref={emailRef}
                required
                placeholder="Your email"
                style={{
                  width: '100%',
                  padding: '10px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
            </div>
            <div style={{ marginBottom: '20px', position: 'relative' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Password</Typography>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                ref={passwordRef}
                required
                placeholder="Password"
                style={{
                  width: '100%',
                  padding: '10px',
                  paddingRight: '40px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
              {/* <IconButton
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '30px',
                  color: '#666',
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton> */}
            </div>
            {/* <div style={{ textAlign: 'right', marginBottom: '20px' }}>
              <Typography variant="body2" style={{ color: '#3488A4', cursor: 'pointer' }}>
                Forgot Password?
              </Typography>
            </div> */}
            {loginError && <Typography color="error" style={{ marginBottom: '10px' }}>{loginError}</Typography>}
            <Button
              type="submit"
              fullWidth
              style={{
                backgroundColor: '#3488A4',
                color: 'white',
                padding: '10px',
                fontSize: '16px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginBottom: '20px',
              }}
            >
              LOGIN
            </Button>
          </form>
          <Typography variant="body2" align="center">
            Don't have an account? <span style={{ color: '#3488A4', cursor: 'pointer' }} onClick={toggleLoginRegister}>Sign Up</span>
          </Typography>
        </div>
      </div>
    );
  };

  const RegisterPopup = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [countryCode, setCountryCode] = useState('+60');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [registerError, setRegisterError] = useState('');

    const nameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmPasswordRef = useRef(null);

    const handleSubmit = async (e) => {
      e.preventDefault();
      if (password !== confirmPassword) {
        setRegisterError(t('Passwords do not match'));
        return;
      }
      setLoading(true);
      try {
        let payload = {
          functionName: 'Register_User',
          postData: {
            name: name,
            email: email,
            password: password,
            phone: `${countryCode}${phone}`,
            business_id: Branch,
            user_type: 'customers',
          }
        }
        const response = await AuthService.registerCustomer(payload);
        setLoading(false);
        if (response.data.status) {
          AlertService.successToast(t("Registration Successful. Your account is pending admin approval. You will receive an email notification once approved."));
          setShowRegisterPopup(false);
          setShowLoginPopup(true);
        } else {
          // Show specific popup for duplicate email/phone
          if (
            response.data.message &&
            (response.data.message.toLowerCase().includes("email already exists") ||
              response.data.message.toLowerCase().includes("phone already exists"))
          ) {
            AlertService.swalErrorAlert(
              t(response.data.message)
            );
          } else {
            AlertService.swalErrorAlert(
              t(response.data.message || "Registration failed. Please try again.")
            );
          }
        }
      } catch (error) {
        setLoading(false);
        setRegisterError(t('Registration failed. Please try again.'));
      }

    };

    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1002,
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          width: '100%',
          maxWidth: '500px',
          position: 'relative',
        }}>
          <IconButton
            onClick={() => setShowRegisterPopup(false)}
            style={{
              position: 'absolute',
              top: '10px',
              left: '10px',
              color: '#000',
            }}
          >
            ←
          </IconButton>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <img src={logo} alt="IPH" style={{ width: '100px', height: '100px', borderRadius: '50%' }} />
          </div>
          <form onSubmit={handleSubmit}>
            {/* Name Input */}
            <div style={{ marginBottom: '20px' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Name</Typography>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                ref={nameRef}
                required
                placeholder="Your name"
                style={{
                  width: '100%',
                  padding: '10px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
            </div>

            {/* Email Input */}
            <div style={{ marginBottom: '20px' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Email</Typography>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                ref={emailRef}
                required
                placeholder="Your email"
                style={{
                  width: '100%',
                  padding: '10px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
            </div>

            {/* Phone Input */}
            <div style={{ marginBottom: '20px' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Phone Number</Typography>
              <PhoneInputContainer>
                <CountryCodeSelect
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  <option value="+60">🇲🇾 +60</option>
                  {/* Add more country options here */}
                </CountryCodeSelect>
                <PhoneInput
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  ref={phoneRef}
                  required
                  placeholder="123456789"
                />
              </PhoneInputContainer>
            </div>

            {/* Password Input */}
            <div style={{ marginBottom: '20px', position: 'relative' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Password</Typography>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                ref={passwordRef}
                required
                placeholder="Password"
                style={{
                  width: '100%',
                  padding: '10px',
                  paddingRight: '40px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '30px',
                  color: '#666',
                }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </div>

            {/* Confirm Password Input */}
            <div style={{ marginBottom: '20px', position: 'relative' }}>
              <Typography variant="body1" style={{ marginBottom: '5px', color: '#9897A1' }}>Confirm Password</Typography>
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                ref={confirmPasswordRef}
                required
                placeholder="Confirm password"
                style={{
                  width: '100%',
                  padding: '10px',
                  paddingRight: '40px',
                  color: '#9897A1',
                  backgroundColor: '#FEFEFE',
                  border: '1px solid #EEEEEE',
                  borderRadius: '5px',
                  fontSize: '16px',
                }}
              />
              <IconButton
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  right: '5px',
                  top: '30px',
                  color: '#666',
                }}
              >
                {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </div>

            {registerError && <Typography color="error" style={{ marginBottom: '10px' }}>{registerError}</Typography>}
            <Button
              type="submit"
              fullWidth
              style={{
                backgroundColor: '#3488A4',
                color: 'white',
                padding: '10px',
                fontSize: '16px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginBottom: '20px',
              }}
            >
              Register
            </Button>
          </form>
          <Typography variant="body2" align="center">
            Already have an account? <span style={{ color: '#3488A4', cursor: 'pointer' }} onClick={toggleLoginRegister}>Login</span>
          </Typography>
        </div>
      </div>
    );
  };


  const setCart = (userId, cartData) => {
    setLoading(true);
    const payload = {
      "functionName": "SetCart",
      user_id: userId,
      "postData": cartData
    };
    //iph todo: 47
    //console.log("payload setCart", payload)
    return DashboardService.setCart(payload)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
          // Extract a human-readable message from various API response shapes
          const pickMessage = (raw) => {
            if (!raw) return 'Error updating cart. Please try again.';
            if (Array.isArray(raw)) {
              const first = raw[0];
              if (typeof first === 'string') return first;
              if (first && typeof first === 'object' && first.message) return first.message;
              const joined = raw.map(r => (r && typeof r === 'object' ? r.message : String(r))).filter(Boolean).join(', ');
              return joined || 'Error updating cart. Please try again.';
            }
            if (typeof raw === 'object') {
              if (raw.message) return pickMessage(raw.message);
              if (raw.error) return pickMessage(raw.error);
              try { return JSON.stringify(raw); } catch (_) { return 'Error updating cart. Please try again.'; }
            }
            return String(raw);
          };

          const friendlyMsg = pickMessage(response?.data?.message);
          if (friendlyMsg === 'Cart Empty' || response.data.message === 'Cart Empty') {
            // Use toaster instead of modal for smoother UX
            AlertService.successToast(t('Cart Empty'));
            // Ensure local and global carts are cleared when the last item is removed
            try {
              setTempCart([]);
            } catch (_) { /* no-op */ }
            try {
              fetchCartDataGlobal();
            } catch (_) { /* no-op */ }
          } else {
            AlertService.swalErrorAlert(friendlyMsg);
          }
        }
        else {
          //iph todo: 47
          //console.log('Cart updated successfully:', response);
          // Sync global cart so Header/Cart/Checkout update instantly
          fetchCartDataGlobal();
          // Show non-intrusive success toast
          try { AlertService.successToast(t('Cart updated')); } catch (_) { /* no-op */ }
        }
        return response;
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error updating cart:', error);
        // Try to surface specific server message if present
        const pickMessage = (raw) => {
          if (!raw) return 'Error updating cart. Please try again.';
          if (Array.isArray(raw)) {
            const first = raw[0];
            if (typeof first === 'string') return first;
            if (first && typeof first === 'object' && first.message) return first.message;
            const joined = raw.map(r => (r && typeof r === 'object' ? r.message : String(r))).filter(Boolean).join(', ');
            return joined || 'Error updating cart. Please try again.';
          }
          if (typeof raw === 'object') {
            if (raw.message) return pickMessage(raw.message);
            if (raw.error) return pickMessage(raw.error);
            try { return JSON.stringify(raw); } catch (_) { return 'Error updating cart. Please try again.'; }
          }
          return String(raw);
        };
        const serverData = error?.response?.data;
        const friendlyMsg = pickMessage(serverData?.message || serverData || error?.message);
        AlertService.swalErrorAlert(friendlyMsg);
        throw error;
      });
  };

  // Delete entire cart for user (used when removing the last remaining item)
  const deleteCart = async (userId) => {
    try {
      setLoading(true);
      const payload = {
        functionName: 'DeleteCart',
        postData: { user_id: userId, cart_id: '' }
      };
      const response = await DashboardService.DeleteCart(payload);
      setLoading(false);
      if (response?.data?.status) {
        try { setTempCart([]); } catch (_) { /* no-op */ }
        try { fetchCartDataGlobal(); } catch (_) { /* no-op */ }
        AlertService.successToast(t('Cart cleared'));
      } else {
        AlertService.swalErrorAlert(t(response?.data?.message || 'Failed to clear cart'));
      }
    } catch (error) {
      setLoading(false);
      AlertService.swalErrorAlert(t('Error clearing cart. Please try again.'));
    }
  };

  const handlePlaceOrder = () => {
    // if (tempCart.length === 0) {
    //   setOpenSnackbar(true);
    // } else {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user._id) {
      setCart(user._id);
    } else {
      setShowLoginPopup(true);
    }
    // }
  };

  // const setCart = (userId) => {
  //   const payload = {
  //     "functionName": "SetCart",
  //     user_id: userId,
  //     "postData": tempCart
  //   };
  //   console.log("payload setCart", payload)
  //   DashboardService.setCart(payload)
  //     .then((response) => {
  //       if (response.data.status === false) {
  //         AlertService.swalErrorAlert(t(response.data.message));
  //       }
  //       else {
  //         setOpenSnackbar1(true);
  //         console.log('Cart set successfully:', response);
  //         // navigate('/CartView');
  //       }

  //     })
  //     .catch((error) => {
  //       console.error('Error setting cart:', error);
  //       AlertService.swalErrorAlert(t("Error setting cart. Please try again."));
  //     });
  // };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCloseSnackbar1 = () => {
    setOpenSnackbar1(false);
  };

  const handleCloseSnackbar2 = () => {
    setOpenSnackbar2(false);
  };

  const getProductQuantity = (productId) => {
    const cartItem = tempCart.find(item => item.product_id === productId);
    return cartItem ? cartItem.quantity : 0;
  };

  const toggleBranchPopup = () => {
    setShowBranchPopup(!showBranchPopup);
  };

  const handleBranchSelect = (branch) => {
    setBranch(branch);
    setShowBranchPopup(false);
  };

  const BranchPopup = () => (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1002,
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        width: '80%',
        maxWidth: '400px',
      }}>
        <h2 style={{ marginBottom: '20px' }}>Select Branch</h2>
        {branches.map((Current_branch) => (
          <div key={Current_branch._id} style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            cursor: 'pointer',
          }} onClick={() => handleBranchSelect(Current_branch._id)}>
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              border: '2px solid #3488A4',
              marginRight: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              {Branch === Current_branch._id && (
                <div style={{
                  width: '12px',
                  height: '12px',
                  borderRadius: '50%',
                  backgroundColor: '#3488A4',
                }} />
              )}
            </div>
            <span>{Current_branch.name}</span>
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button onClick={() => setShowBranchPopup(false)} style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: 'white',
            color: '#3488A4',
            border: '1px solid #3488A4',
            borderRadius: '5px',
            cursor: 'pointer',
          }}>
            Cancel
          </button>
          <button onClick={() => setShowBranchPopup(false)} style={{
            padding: '10px 20px',
            backgroundColor: '#3488A4',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );

  const handleRefundPolicy = () => {
    setSidebarOpen(false);  // Close the sidebar
    navigate('/customer/refund-policy');  // Navigate to Refund Policy page
  };

  const handleRefundPolicyOld = () => {
    setSidebarOpen(false);  // Close the sidebar when showing the Refund Policy popup
    const refundPolicyContent = (
      <>
        <h2>Refund Policy</h2>
        <p><strong>1. Introduction</strong><br />
          At IPH Pharmaceuticals Sdn Bhd, we are committed to providing high-quality pharmaceutical products and services to our customers. If you are not satisfied with your purchase, please review our refund policy below.</p>
        <p><strong>2. Eligibility for Refunds</strong><br />
          Refunds are applicable under the following conditions:
          <ul>
            <li>The product is damaged, defective, or incorrectly supplied.</li>
            <li>The product is unopened, unused, and in its original packaging.</li>
            <li>The return request is made within 7 days of receiving the product.</li>
            <li>The product is within its shelf life and has not been expired.</li>
          </ul>
        </p>
        <p><strong>3. Non-Refundable Items</strong><br />
          We are unable to provide refunds for the following items:
          <ul>
            <li>Medicines or products that have been opened or used.</li>
            <li>Custom or special-order products made specifically for you.</li>
            <li>Perishable items such as cold-chain pharmaceuticals.</li>
            <li>Products purchased more than 7 days ago.</li>
          </ul>
        </p>

        <p><strong>4. Return Process</strong><br />
          To initiate a return, please contact our customer service team at [customer.service@iphpharma.com] or call us at [Phone Number]. Provide the following details:
          <ul>
            <li>Order number</li>
            <li>Reason for return</li>
            <li>Product name and quantity</li>
            <li>Photos of the damaged or incorrect product (if applicable)</li>
            <li>Our team will assist you in processing the return or exchange</li>
          </ul>
        </p>

        <p><strong>5. Refund Procedure</strong><br />
          If your return is approved, we will process the refund to your original method of payment. Please allow up to 14 business days for the refund to be processed and reflected in your account, depending on your bank's processing time.
        </p>

        <p><strong>6. Shipping Fees</strong><br />
          Shipping fees are non-refundable, and customers will be responsible for the return shipping costs unless the product is defective or damaged.
        </p>

        <p><strong>7. Damaged or Defective Products</strong><br />
          If the product is found to be defective or damaged upon receipt, please notify us within 3 days of receiving the item. We will offer a full refund or replacement at no extra cost, along with free return shipping.
        </p>

        <p><strong>8. Contact Us</strong><br />
          For any inquiries regarding refunds or returns, please contact us at:
        </p>
        <p>
          <br />
          IPH Pharmaceuticals Sdn Bhd
        </p>


      </>
    );
    setPopupContent(refundPolicyContent);
    setShowPopup(true);  // Open the Refund Policy popup
  };

  const handlePrivacyPolicy = () => {
    setSidebarOpen(false);  // Close the sidebar when showing the Terms & Conditions popup
    const termsContent = (
      <>
        <h2>Privacy Policy</h2>
        <p><strong>1. Introduction</strong><br />
          These Privacy Policy govern the use of the services and products provided by IPH Pharmaceuticals Sdn Bhd. By accessing or using our services, you agree to comply with and be bound by these Terms.</p>
        <p><strong>2. Services Provided</strong><br />
          IPH Pharmaceuticals Sdn Bhd supplies integrated pharmaceutical services and products to independent medical practitioners in Malaysia. Our services include the supply of medicines, medical equipment, and pharmaceutical consultation.</p>
        <p><strong>3. Account Registration</strong><br />
          To place an order, you must register an account with us, providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
        <p><strong>4. Ordering and Payment</strong><br />
          By placing an order through our website or other sales channels, you agree to pay the full price of the products, including any applicable taxes and shipping fees. We accept payments through various methods including bank transfers, credit cards, and online payment gateways.</p>
        <p><strong>5. Pricing and Availability</strong><br />
          While we strive to provide accurate pricing and product availability, IPH Pharmaceuticals Sdn Bhd reserves the right to correct any errors in pricing or availability at any time. If a product is out of stock or pricing is incorrect, we will notify you as soon as possible and offer alternatives or a full refund if necessary.</p>
        <p><strong>6. Delivery and Shipping</strong><br />
          IPH Pharmaceuticals Sdn Bhd will process and ship your order as quickly as possible. Delivery times may vary depending on your location. We are not responsible for delays caused by third-party shipping carriers or force majeure events.</p>
        <p><strong>7. Returns and Refunds</strong><br />
          Please refer to our Refund Policy for detailed terms regarding returns and refunds.</p>
        <p><strong>8. Intellectual Property</strong><br />
          All content, logos, designs, and materials used on our website or provided through our services are the property of IPH Pharmaceuticals Sdn Bhd and are protected by copyright and intellectual property laws. You may not reproduce, distribute, or use these materials without prior written consent from IPH Pharmaceuticals Sdn Bhd.</p>
        <p><strong>9. Limitation of Liability</strong><br />
          IPH Pharmaceuticals Sdn Bhd's liability is limited to the amount paid for the product or service in the event of a defect or issue. We are not liable for any indirect, incidental, or consequential damages arising from the use or inability to use our products or services.</p>
        <p><strong>10. Privacy and Data Protection</strong><br />
          We respect your privacy and are committed to protecting your personal information. Please review our Privacy Policy for more information on how we collect, use, and safeguard your data.</p>
        <p><strong>11. Governing Law</strong><br />
          These Privacy Policy are governed by the laws of Malaysia. Any disputes arising from the use of our services shall be resolved in accordance with Malaysian law.</p>
        <p><strong>12. Amendments</strong><br />
          IPH Pharmaceuticals Sdn Bhd reserves the right to update or amend these Privacy Policy at any time. Any changes will be communicated to you via email or through our website. Continued use of our services following any changes constitutes your acceptance of the new Terms.</p>
        <p><strong>13. Contact Us</strong><br />
          For any questions or concerns about these Privacy Policy, please contact us at:</p>
        <p>IPH Pharmaceuticals Sdn Bhd</p>
      </>
    );
    setPopupContent(termsContent);
    setShowPopup(true);  // Open the Terms & Conditions popup
  };

  const handleTerms = () => {
    setSidebarOpen(false);  // Close the sidebar
    navigate('/customer/terms-conditions');  // Navigate to Terms & Conditions page
  };

  const handleTermsOld = () => {
    setSidebarOpen(false);  // Close the sidebar when showing the Terms & Conditions popup
    const termsContent = (
      <>
        <h2>Terms & Conditions</h2>
        <p><strong>1. Introduction</strong><br />
          These Terms & Conditions govern the use of the services and products provided by IPH Pharmaceuticals Sdn Bhd. By accessing or using our services, you agree to comply with and be bound by these Terms.</p>
        <p><strong>2. Services Provided</strong><br />
          IPH Pharmaceuticals Sdn Bhd supplies integrated pharmaceutical services and products to independent medical practitioners in Malaysia. Our services include the supply of medicines, medical equipment, and pharmaceutical consultation.</p>
        <p><strong>3. Account Registration</strong><br />
          To place an order, you must register an account with us, providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
        <p><strong>4. Ordering and Payment</strong><br />
          By placing an order through our website or other sales channels, you agree to pay the full price of the products, including any applicable taxes and shipping fees. We accept payments through various methods including bank transfers, credit cards, and online payment gateways.</p>
        <p><strong>5. Pricing and Availability</strong><br />
          While we strive to provide accurate pricing and product availability, IPH Pharmaceuticals Sdn Bhd reserves the right to correct any errors in pricing or availability at any time. If a product is out of stock or pricing is incorrect, we will notify you as soon as possible and offer alternatives or a full refund if necessary.</p>
        <p><strong>6. Delivery and Shipping</strong><br />
          IPH Pharmaceuticals Sdn Bhd will process and ship your order as quickly as possible. Delivery times may vary depending on your location. We are not responsible for delays caused by third-party shipping carriers or force majeure events.</p>
        <p><strong>7. Returns and Refunds</strong><br />
          Please refer to our Refund Policy for detailed terms regarding returns and refunds.</p>
        <p><strong>8. Intellectual Property</strong><br />
          All content, logos, designs, and materials used on our website or provided through our services are the property of IPH Pharmaceuticals Sdn Bhd and are protected by copyright and intellectual property laws. You may not reproduce, distribute, or use these materials without prior written consent from IPH Pharmaceuticals Sdn Bhd.</p>
        <p><strong>9. Limitation of Liability</strong><br />
          IPH Pharmaceuticals Sdn Bhd's liability is limited to the amount paid for the product or service in the event of a defect or issue. We are not liable for any indirect, incidental, or consequential damages arising from the use or inability to use our products or services.</p>
        <p><strong>10. Privacy and Data Protection</strong><br />
          We respect your privacy and are committed to protecting your personal information. Please review our Privacy Policy for more information on how we collect, use, and safeguard your data.</p>
        <p><strong>11. Governing Law</strong><br />
          These Terms & Conditions are governed by the laws of Malaysia. Any disputes arising from the use of our services shall be resolved in accordance with Malaysian law.</p>
        <p><strong>12. Amendments</strong><br />
          IPH Pharmaceuticals Sdn Bhd reserves the right to update or amend these Terms & Conditions at any time. Any changes will be communicated to you via email or through our website. Continued use of our services following any changes constitutes your acceptance of the new Terms.</p>
        <p><strong>13. Contact Us</strong><br />
          For any questions or concerns about these Terms & Conditions, please contact us at:</p>
        <p>IPH Pharmaceuticals Sdn Bhd</p>
      </>
    );
    setPopupContent(termsContent);
    setShowPopup(true);  // Open the Terms & Conditions popup
  };



  const filterProducts = (products, term) => {
    if (!term) return products;
    return products.filter(product =>
      product.item_name.toLowerCase().includes(term?.toLowerCase())
    );
  };
  // Function to get all products across categories
  const getAllProducts = () => {
    return Object.values(categorizedProducts)?.flat();
  };

  // Filtered products
  const filteredProducts = filterProducts(getAllProducts(), searchTerm);
  const scrollToCategory = useCallback((categoryId) => {
    const element = categoryRefs.current[categoryId];
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, []);


  useEffect(() => {
    if (activeCategory) {
      scrollToCategory(activeCategory);
    }
  }, [activeCategory, scrollToCategory]);

  const handleCategoryClick = (category) => {
    setActiveCategory(category ? category._id : null);
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.pageYOffset + 200; // Offset to trigger category change earlier
  //     let currentCategory = categories[0];

  //     for (const category of categories) {
  //       const element = categoryRefs.current[category?._id];
  //       if (element && scrollPosition >= element.offsetTop) {
  //         currentCategory = category;
  //       } else {
  //         break;
  //       }
  //     }

  //     setActiveCategory(currentCategory?._id);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [categories]);


  return (
    <div ref={scrollRef} style={{ overflow: 'hidden', position: 'relative', height: '100vh' }}>
      <Header
        handleRefundPolicy={handleRefundPolicy}
        handleTerms={handleTerms}
        setSidebarOpen={setSidebarOpen}
        CartView={CartView}
        isCartOpen={isCartOpen}
        setIsCartOpen={setIsCartOpen}
        tempCart={tempCart}
        logo={logo}
        setSearchTerm={setSearchTerm}
        handleCategoryClick={handleCategoryClick}
        categories={categories}
        activeCategory={activeCategory}
        showProfile={showProfile}
        showOrders={showOrders}
        setShowCheckout={setShowCheckoutWithScroll}
        showCheckout={showCheckout}
        setShowOrders={setShowOrdersWithScroll}
        setShowProfile={setShowProfileWithScroll}
        setProduct_Details={setProduct_Details}
        setShowLoginPopup={setShowLoginPopup}
        categorizedProducts={searchTerm ? filteredProducts : categorizedProducts}

      />
      {sidebarOpen && (
        <Sidebar
          CartView={CartView}
          handleRefundPolicy={handleRefundPolicy}
          handleTerms={handleTerms}
          handleCategoryClick={handleCategoryClick}
          setShowLoginPopup={setShowLoginPopup}
          categories={categories}
          setShowCheckout={setShowCheckoutWithScroll}
          setSelectedCategory={setSelectedCategory}
          setSidebarOpen={setSidebarOpen}
          setShowOrders={setShowOrdersWithScroll}
          setShowProfile={setShowProfileWithScroll}
          setProduct_Details={setProduct_Details}
          categorizedProducts={searchTerm ? filteredProducts : categorizedProducts}
          productStock={productStock}
        />
      )}

      <main className="store-main-content" style={{ width: '100%', padding: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '80px' }}>
        </div>
        <>
          {showProfile ? (
            <LazyWrapper
              scrollToTopOnMount={true}
              skeletonType="profile"
              skeletonCount={1}
              loadingDelay={600}
            >
              <Box sx={{ marginTop: '40px' }} className="content-fade-in">
                <MyProfile
                  onClose={() => setShowProfileWithScroll(false)}
                  productStock={productStock}
                  onProfileUpdate={refreshUserData}
                />
              </Box>
            </LazyWrapper>
          ) :
            showOrders ?
              (
                <LazyWrapper
                  scrollToTopOnMount={true}
                  skeletonType="orders"
                  skeletonCount={3}
                  loadingDelay={600}
                >
                  <Box sx={{ marginTop: '40px' }} className="content-fade-in">
                    <MyOrders onClose={() => setShowOrdersWithScroll(false)} productStock={productStock} />
                  </Box>
                </LazyWrapper>
              ) :
              showCheckout ?
                (
                  <LazyWrapper
                    scrollToTopOnMount={true}
                    skeletonType="checkout"
                    skeletonCount={1}
                    loadingDelay={700}
                  >
                    <Box sx={{ marginTop: '40px' }} className="content-fade-in">
                      <CheckoutPage
                        onClose={() => setShowCheckoutWithScroll(false)}
                        searchTerm={searchTerm}
                        categories={categories}
                        setIsCartOpen={setIsCartOpen}
                        setShowLoginPopup={setShowLoginPopup}
                        productDetails={productDetails}
                        setProduct_Details={setProduct_Details}
                        activeCategory={activeCategory}
                        categorizedProducts={searchTerm ? filteredProducts : categorizedProducts}
                        handleIncrement={handleIncrement}
                        handleDecrement={handleDecrement}
                        handleVariationChange={handleVariationChange}
                        getProductQuantity={getProductQuantity}
                        handleCategoryClick={handleCategoryClick}
                        tempCart={tempCart}
                        handleRefundPolicy={handleRefundPolicy}
                        handleTerms={handleTerms}
                        handlePrivacyPolicy={handlePrivacyPolicy}
                        setShowOrders={setShowOrdersWithScroll}
                        setShowProfile={setShowProfileWithScroll}
                        productStock={productStock}
                      />
                    </Box>
                  </LazyWrapper>
                ) : (
                  <LazyWrapper
                    scrollToTopOnMount={false}
                    skeletonType="product-grid"
                    skeletonCount={8}
                    loadingDelay={400}
                  >
                    <div className="content-fade-in">
                      <CategoryContent
                        searchTerm={searchTerm}
                        handleAddToCart={handleAddToCart}
                        categories={categories}
                        setShowLoginPopup={setShowLoginPopup}
                        productDetails={productDetails}
                        activeCategory={activeCategory}
                        categorizedProducts={searchTerm ? filteredProducts : categorizedProducts}
                        handleIncrement={handleIncrement}
                        handleDecrement={handleDecrement}
                        syncCartNow={syncCartNow}
                        handleVariationChange={handleVariationChange}
                        getProductQuantity={getProductQuantity}
                        handleCategoryClick={handleCategoryClick}
                        tempCart={tempCart}
                        setShowOrders={setShowOrdersWithScroll}
                        setShowProfile={setShowProfileWithScroll}
                        setProduct_Details={setProduct_Details}
                        banners={banners}
                        productStock={productStock}
                      />
                      {/* Infinite scroll sentinel */}
                      <div ref={loadMoreRef} style={{ height: 1 }} />
                      {isFetchingMore && (
                        <div style={{ textAlign: 'center', padding: '10px', color: '#666' }}>Loading more...</div>
                      )}
                      {!hasMore && (
                        <div style={{ textAlign: 'center', padding: '10px', color: '#999' }}>No more items</div>
                      )}
                    </div>
                  </LazyWrapper>
                )}
        </>
        <PopupModal show={showPopup} content={popupContent} onClose={() => setShowPopup(false)} />
      </main>
      <Footer />

      {showBranchPopup && <BranchPopup />}
      {showLoginPopup && <LoginPopup />}
      {showRegisterPopup && <RegisterPopup />}

      {/* Local Toast container to ensure toasts render on this page */}
      <ToastContainer position="top-right" newestOnTop autoClose={5000} hideProgressBar={false} closeOnClick pauseOnHover draggable />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          Please select at least one item.
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackbar1}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar1}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar1} severity="success" sx={{ width: '100%' }}>
          Proceed to cart.
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackbar2}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar2}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar2} severity="warning" sx={{ width: '100%' }}>
          Please Login First.
        </Alert>
      </Snackbar>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes slideIn {
            from { transform: translateX(-100%); }
            to { transform: translateX(0); }
          }
          
          @keyframes slideUp {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }
                    
          .fade-in {
            animation: fadeIn 0.5s ease-out;
          }
          
          .slide-in {
            animation: slideIn 0.3s ease-out;
          }
          
          .slide-up {
            animation: slideUp 0.3s ease-out;
          }
          
          .category-button {
            transition: background-color 0.3s, color 0.3s;
          }
          
          #scrollRef::-webkit-scrollbar {
            display: none;
          }
  
          #scrollRef {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
  
          @media (max-width: 768px) {
            .category-button {
              padding: 8px 15px;
              margin-right: 5px;
              font-size: 12px
            }
          }
        `}
      </style>
    </div>
  );
};

export default App;